module.exports = (__webpack_require__(0))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./src/events.js from dll-reference girder_plugin_jobs
// module id = 12
// module chunks = 0